import { Card } from '@/components/ui/card';
import { ThemeToggle } from '@/components/ui/theme-toggle';

interface AuthLayoutProps {
  children: React.ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Background with grid pattern and gradient */}
      <div className="fixed inset-0 -z-10 bg-background bg-grid-black/10 dark:bg-grid-white/10">
        <div className="absolute inset-0 bg-gradient-to-br from-primary/10 via-transparent to-secondary/10 backdrop-blur-sm"></div>
      </div>
      
      {/* Floating theme toggle on top right */}
      <div className="absolute top-4 right-4 z-10">
        <ThemeToggle />
      </div>
      
      {/* Main content */}
      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-md space-y-6">
          <div className="flex flex-col items-center">
            <img 
              src="/logo.svg" 
              alt="FlexHelp" 
              className="h-48 w-auto animate-pulse-subtle"
              style={{ fill: '#53253e' }} 
            />
            <p className="text-sm text-muted-foreground -mt-4">
              Property maintenance made simple
            </p>
          </div>

          {children}
        </div>
      </div>
    </div>
  );
}